import { Button, Input, Modal } from "antd";
import { useEffect, useRef } from "react";

const OfferDetailsADialog = ({
  taansOpen,
  setTaansOpen,
  taansData,
  setTaansData,
  handleTaansBillSave,
  offerARate,
}) => {
  const inputRef = useRef(null);
  const rateRef = useRef(null);
  const disPerRef = useRef(null);
  const disAmtRef = useRef(null);
  const saveRef = useRef(null);
  const handelCancel = () => {
    setTaansOpen(false);
    setTaansData([]);
  };
  useEffect(() => {
    if (taansOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [taansOpen]);

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };

  return (
    <Modal
      className="oa-modal"
      title={<div className="oa-title">Product Details</div>}
      open={taansOpen}
      closable={false}
      footer={null}
      maskStyle={{
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
      }}
      afterOpenChange={(open) => {
        if (open && inputRef.current) {
          inputRef.current.focus();
        }
      }}
    >
      {/* ---------- embedded styles (single file) ---------- */}
      <style>{`
        .oa-modal .ant-modal-content{padding:0;border-radius:18px;overflow:hidden}
        .oa-modal .ant-modal-header{margin:0;padding:0;background:transparent}
        .oa-modal .ant-modal-body{padding:14px;background:#eef1f8}

        .oa-title{background:linear-gradient(135deg,#114a3d,#1f8f6a);color:#fff;font-weight:800;font-size:16px;text-align:center;padding:14px 12px;letter-spacing:.4px}

        .oa-head{background:linear-gradient(135deg,#162566,#2a3c8f);color:#fff;border-radius:14px;padding:10px 14px;box-shadow:0 4px 12px rgba(22,37,102,.3)}
        .oa-head-top{display:flex;align-items:center;justify-content:space-between;gap:10px}
        .oa-head-l{font-size:11px;font-weight:700;text-transform:uppercase;opacity:.85}
        .oa-chip{background:linear-gradient(180deg,#ffd666,#f2b01e);color:#3b2a00;font-weight:800;font-size:17px;padding:4px 14px;border-radius:10px}
        .oa-pname{margin-top:8px;font-size:13px;font-weight:700;color:#e6ebff;word-break:break-word}

        .oa-qtycard{margin-top:10px;background:#fff;border:2px solid #52bd91;border-radius:14px;padding:8px 12px 10px;box-shadow:0 3px 10px rgba(82,189,145,.25)}
        .oa-label{display:flex;align-items:center;justify-content:space-between;font-size:11px;font-weight:800;color:#6b76a8;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px}
        .oa-hint{font-size:10px;font-weight:700;color:#1b8a5a;background:#e3f7ee;border-radius:6px;padding:1px 8px;text-transform:none;letter-spacing:0}
        .oa-qty{height:46px;border-radius:10px!important;font-size:22px;font-weight:800;color:#162566;width:100%}

        .oa-grid{margin-top:10px;display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px}
        .oa-card{background:#fff;border:1.5px solid #e1e6f4;border-radius:14px;padding:8px 10px 10px}
        .oa-ro{height:38px;border-radius:10px!important;font-size:15px;font-weight:700;color:#162566;width:100%}
        .oa-ro.ant-input-disabled,.oa-ro[disabled]{background:#f4f7fd!important;color:#162566!important}

        .oa-result{margin-top:10px;display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .oa-tile{border-radius:14px;padding:10px 12px;color:#fff}
        .oa-tile.act{background:linear-gradient(135deg,#ffb020,#f08a00)}
        .oa-tile.amt{background:linear-gradient(135deg,#1f8f6a,#52bd91)}
        .oa-tile-l{font-size:11px;font-weight:700;text-transform:uppercase;opacity:.9}
        .oa-tile-v{font-size:20px;font-weight:800;margin-top:2px}

        .oa-actions{margin-top:12px;display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .oa-btn{height:44px!important;border-radius:12px!important;font-weight:800!important;font-size:14px!important}
        .oa-cancel{background:#fff!important;border:1.5px solid #BF092F!important;color:#BF092F!important}
        .oa-save{background:linear-gradient(135deg,#1f8f6a,#52bd91)!important;border:0!important;color:#fff!important}
      `}</style>

      {/* Design code + product name (read-only) */}
      <div className="oa-head">
        <div className="oa-head-top">
          <span className="oa-head-l">Design Code</span>
          <span className="oa-chip">{taansData[0]?.DesignCode || "-"}</span>
        </div>
        <div className="oa-pname">{taansData[0]?.ProdName}</div>
      </div>

      {/* Qty (the editable field) */}
      <div className="oa-qtycard">
        <div className="oa-label">
          <span>Qty</span>
          <span className="oa-hint">Max 3</span>
        </div>
        <Input
          placeholder="Enter Qty"
          className="oa-qty"
          ref={inputRef}
          inputMode="decimal"
          value={taansData[0]?.stock ?? 0}
          onFocus={(e) => e.target.select()}
          onChange={(e) => {
            const input = e.target.value;

            // allow numbers with up to 2 decimal places
            if (!/^\d*\.?\d{0,2}$/.test(input)) return;

            const qty = Number(input);
            const maxQty = 3;

            // stop if qty exceeds max
            if (qty > maxQty) return;

            const rate = Number(offerARate) || 0;

            // handle qty logic
            const finalQty = qty;
            const oQty = qty === 2 ? taansData[0]?.OQTY2 : taansData[0]?.OQTY3;

            // prevent divide by zero
            const rateValue = finalQty > 0 ? (oQty || 0) / finalQty : 0;

            const price = qty === 1 ? rate : rateValue;

            setTaansData((prev) =>
              prev.map((item) =>
                item.DesignCode === taansData[0]?.DesignCode
                  ? {
                    ...item,
                    stock: qty,
                    CPrice: price,
                    offer: price,
                  }
                  : item
              )
            );
          }}
          onKeyDown={(e) => {
            handleKeyDown(e, saveRef);
          }}
        />
      </div>

      {/* Rate / Dis Per / Dis Amt (disabled, same as original) */}
      <div className="oa-grid">
        <div className="oa-card">
          <div className="oa-label">Rate</div>
          <Input
            placeholder="Enter Rate"
            className="oa-ro"
            disabled
            ref={rateRef}
            value={taansData[0]?.CPrice ?? 0}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(val)) {
                const disPer = taansData[0]?.Disper;
                const rateValue = val * Number(disPer);
                const disAmt = Number(rateValue) / 100;
                const ActRate = taansData[0]?.stock * val;

                setTaansData((prev) =>
                  prev.map((item) =>
                    item.DesignCode === taansData[0]?.DesignCode
                      ? {
                        ...item,
                        CPrice: val,
                        Disamt: 0,
                        offer: ActRate,
                      }
                      : item
                  )
                );
              }
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, disPerRef);
            }}
          />
        </div>

        <div className="oa-card">
          <div className="oa-label">Dis %</div>
          <Input
            placeholder="Enter Dis Per"
            className="oa-ro"
            disabled
            ref={disPerRef}
            value={taansData[0]?.Disper ?? 0}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (!/^\d*\.?\d*$/.test(val)) return;
              const rate = taansData[0]?.CPrice;
              const rateValue = rate * val;
              const disAmt = rateValue / 100;
              const ActRate = rate - disAmt;

              setTaansData((prev) =>
                prev.map((item) =>
                  item.DesignCode === taansData[0]?.DesignCode
                    ? {
                      ...item,
                      Disper: val,
                      Disamt: 0,
                      offer: ActRate,
                    }
                    : item
                )
              );
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, disAmtRef);
            }}
          />
        </div>

        <div className="oa-card">
          <div className="oa-label">Dis Amt</div>
          <Input
            placeholder="Enter Dis Amt"
            className="oa-ro"
            disabled
            ref={disAmtRef}
            value={taansData[0]?.Disamt ?? 0}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(val)) {
                //   const updatedValue = val === 0 ? 0 : Number(val);
                const rate = taansData[0]?.CPrice;
                const ActRate = rate - val;

                setTaansData((prev) =>
                  prev.map((item) =>
                    item.DesignCode === taansData[0]?.DesignCode
                      ? { ...item, Disamt: val, offer: ActRate }
                      : item
                  )
                );
              }
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, saveRef);
            }}
          />
        </div>
      </div>

      {/* Act Rate / Amount (read-only) */}
      <div className="oa-result">
        <div className="oa-tile act">
          <div className="oa-tile-l">Act Rate</div>
          <div className="oa-tile-v">
            {Number(taansData[0]?.offer)?.toFixed(2) || 0}
          </div>
        </div>
        <div className="oa-tile amt">
          <div className="oa-tile-l">Amount</div>
          <div className="oa-tile-v">
            {Number(taansData[0]?.stock * taansData[0]?.offer)?.toFixed(2) || 0}
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="oa-actions">
        <Button
          className="oa-btn oa-cancel"
          onClick={() => {
            handelCancel();
          }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          className="oa-btn oa-save"
          ref={saveRef}
          onClick={() => {
            handleTaansBillSave();
          }}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};
export default OfferDetailsADialog;